@if (this.multisortEvent) {
  <tr class="d-none d-lg-table-row">
    <th [attr.colspan]="columns.length">
      <p class="mb-1">Для сортировки по нескольким столбцам <strong>зажмите</strong> клавишу <strong>shift</strong></p>
    </th>
  </tr>
}

<tr>
  @for (column of columns; track column) {
    <th [ngStyle]="{'width': (column.width) ? column.width : 'auto'}">
      <!--mobile-->
      @if (!embededService) {
        @if (column.sortable || column.templateHead) {
          <div class="d-flex w-100 d-md-none justify-content-between c-pointer" mobile-sort [mobile_sort_caption]="column.caption" [mobile_sort_template]="column.templateHead" [mobile_sort_exist]="column.sortable" [mobile_sort_sort]="sort[column.name]" (mobile_sort_change)="mobileSortChange($event, column.name)">
            @if (!column.templateHead) {
              <span>{{column.caption}}</span>
            }
            @if (column.templateHead) {
              <ng-template
                [ngTemplateOutlet]="column.templateHead"
              [ngTemplateOutletContext]="{column: column}"></ng-template>
            }
            @if (column.sortable) {
<i class="icon" [ngClass]="{'icon_new-sort-none': !sort[column.name],
                                    'icon_new-sort-down': 'asc' == sort[column.name],
                                    'icon_new-sort-up': 'desc' == sort[column.name]}"></i>
            }
            <div class="mobile-sort-container">
              <ng-container #mobileSortContainer></ng-container>
            </div>
          </div>
        }
        @if (!column.sortable &&  !column.templateHead) {
          <div class="d-flex w-100 d-md-none justify-content-between c-pointer">
            {{column.caption}}
          </div>
        }
      }
      <!--desktop-->
      <div class="d-none d-none-sm-fix d-md-block" [ngClass]="{'d-block': embeddedService}">
        @if (!column.sortable && !column.templateHead) {
          <span>{{column.caption}}</span>
        }
        @if (column.sortable && !column.templateHead) {
          <a class="caption_sort"
            href="javascript:void(0)" (click)="sortChange(column.name)">
            {{column.caption}}
        <i class="icon" [ngClass]="{'icon_new-sort-none': !sort[column.name],
                                  'icon_new-sort-down': 'asc' == sort[column.name],
                                  'icon_new-sort-up': 'desc' == sort[column.name]}"></i>
          </a>
        }
        @if (column.templateHead) {
          <div class="row no-gutters align-items-center flex-nowrap">
            <div class="col table__input">
              @if (column.templateHead) {
                <ng-template
                  [ngTemplateOutlet]="column.templateHead"
                [ngTemplateOutletContext]="{column: column}"></ng-template>
              }
            </div>
            @if (column.sortable) {
              <div class="col-auto sort-block">
                <a href="javascript:void(0)" (click)="sortChange(column.name)">
            <i class="icon" [ngClass]="{'icon_new-sort-none': !sort[column.name],
                                      'icon_new-sort-down': 'asc' == sort[column.name],
                                      'icon_new-sort-up': 'desc' == sort[column.name]}"></i>
                </a>
              </div>
            }
          </div>
        }
      </div>
    </th>
  }
</tr>
